import BackButton from "app/components/BackButton/BackButton";
import { IconClose } from "app/components/Icon/Icon";
import { SessionHelper } from "app/helpers/sessionHelper";
import { ResponsiveScreenSizes } from "app/utils/const";
import { useState } from "react";
import { FormattedMessage } from "react-intl";
import Media from "react-media";
import RenderUpdateMessage from "../RenderUpdateMessage/RenderUpdateMessage";

const ProfileHeaderNavigation = ({ history }): React.JSX.Element => {
  const [state, setState] = useState({
    updateSuccess: false,
    updateFailed: false,
  });

  // Logic to take user back
  const back = () => {
    history.back || history.goBack();
  };

  // display the header for the profile screen
  // this consists of the page name and the back arrow to return to the settings view
  return (
    <div>
      <div className="profile__component--header-navigation">
        <div className="profile__component__title">
          <RenderUpdateMessage state={state} />
          {/* responsive to all three screen sizes */}
          <Media
            query={`(max-width: ${ResponsiveScreenSizes.mobile})`}
            render={() => <BackButton history={history} mobile={true} />}
          />
          <Media
            query={`(min-width: ${ResponsiveScreenSizes.desktop})`}
            render={() =>
              SessionHelper.isAsianSessionView() ? (
                <div onClick={back} className="title__back">
                  <IconClose />
                </div>
              ) : (
                <BackButton className="title__back" history={history} />
              )
            }
          />
          <span className="back-button__text">
            <FormattedMessage tagName="span" id="settings-accountdetails" />
          </span>
        </div>
      </div>
    </div>
  );
};
export default ProfileHeaderNavigation;
